import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { RequireAdmin } from "../auth/RequireAdmin";
import { Index } from "../Pages/Index/Index";
import { CookieBanner } from "../components/CookieBanner/CookieBanner";

/** Home eager (LCP). Resto en chunks; admin no entra en el bundle público. */
const PontePie = lazy(() =>
  import("../Pages/PontePie/PontePie").then((m) => ({ default: m.PontePie }))
);
const Cita = lazy(() => import("../Pages/Cita/Cita").then((m) => ({ default: m.Cita })));
const Contacto = lazy(() =>
  import("../Pages/Contacto/Contacto").then((m) => ({ default: m.Contacto }))
);
const Servicios = lazy(() =>
  import("../Pages/Servicios/Servicios").then((m) => ({ default: m.Servicios }))
);
const Legal = lazy(() => import("../Pages/Legal/Legal").then((m) => ({ default: m.Legal })));
const NotFound = lazy(() =>
  import("../Pages/NotFound/NotFound").then((m) => ({ default: m.NotFound }))
);
const AdminLogin = lazy(() =>
  import("../Pages/Admin/AdminLogin").then((m) => ({ default: m.AdminLogin }))
);
const AdminShell = lazy(() =>
  import("../Pages/Admin/AdminShell").then((m) => ({ default: m.AdminShell }))
);
const AdminCalendar = lazy(() =>
  import("../Pages/Admin/AdminCalendar").then((m) => ({ default: m.AdminCalendar }))
);
const AdminPatients = lazy(() =>
  import("../Pages/Admin/AdminPatients").then((m) => ({ default: m.AdminPatients }))
);
const AdminPatientDetail = lazy(() =>
  import("../Pages/Admin/AdminPatientDetail").then((m) => ({ default: m.AdminPatientDetail }))
);
const AdminUsers = lazy(() =>
  import("../Pages/Admin/AdminUsers").then((m) => ({ default: m.AdminUsers }))
);
const AdminHome = lazy(() =>
  import("../Pages/Admin/AdminHome").then((m) => ({ default: m.AdminHome }))
);

function RouteFallback() {
  return (
    <div className="route-fallback" role="status" aria-live="polite">
      Cargando…
    </div>
  );
}

export const Rutas = () => {
  return (
    <>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/pontepie" element={<PontePie />} />
          <Route path="/cita" element={<Cita />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/privacidad" element={<Legal kind="privacy" />} />
          <Route path="/aviso-legal" element={<Legal kind="legal" />} />
          <Route path="/cookies" element={<Legal kind="cookies" />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<RequireAdmin />}>
            <Route path="/admin" element={<AdminShell />}>
              <Route index element={<AdminHome />} />
              <Route path="calendario" element={<AdminCalendar />} />
              <Route path="pacientes" element={<AdminPatients />} />
              <Route path="pacientes/:id" element={<AdminPatientDetail />} />
              <Route path="usuarios" element={<AdminUsers />} />
            </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <CookieBanner />
    </>
  );
};
